import { createRouter, createWebHistory } from 'vue-router'
import HomePage from '@/views/HomePage'
import LoginPage from '@/views/LoginPage'
import PasswordPage from '@/views/PasswordPage'
import OrganizationPage from '@/views/OrganizationPage'
import FacilitiesPage from '@/views/FacilitiesPage'
import CDCDevicesPage from '@/views/CDCDevicesPage'
import CDCSensorsPage from '@/views/CDCSensorsPage'
import SensorEventsPage from '@/views/SensorEventsPage'
import CDCDataValuesPage from '@/views/CDCDataValuesPage'
import UserPage from '@/views/UserPage'
import CollectionAddressesPage from '@/views/CollectionAddressesPage'
import UserPushTokensPage from '@/views/UserPushTokensPage'
import PricingPage from '@/views/PricingPage'
import AnomaliesPage from '@/views/AnomaliesPage'
import ApiTokensPage from '@/views/ApiTokensPage'
import EmissionCoveragePage from '@/views/EmissionCoveragePage'
// import EmissionsPage from '@/views/EmissionPage'

export default createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes: [
    {
      path: '/',
      name: 'home',
      component: HomePage
    }, {
      path: '/login',
      name: 'login',
      component: LoginPage
    }, {
      // deep link for marketing sites: logs the demo user in automatically
      path: '/demo',
      name: 'demo',
      component: LoginPage,
      meta: { autoDemo: true }
    }, {
      path: '/changepassword/:token',
      name: 'changepassword',
      component: PasswordPage
    }, {
      path: '/organizations',
      name: 'organizations',
      component: OrganizationPage
    }, {
      path: '/facilities/:organizationid',
      name: 'facilities',
      component: FacilitiesPage
    }, {
      path: '/cdcdevices/:facilityid',
      name: 'cdcdevices',
      component: CDCDevicesPage
    }, {
      path: '/cdcsensors/:cdcdeviceid',
      name: 'cdcsensors',
      component: CDCSensorsPage
    }, {
      path: '/sensorevents/:cdcsensorid',
      name: 'sensorevents',
      component: SensorEventsPage
    }, {
      path: '/cdcdatavalues/:cdcdeviceid/:from/:until',
      name: 'cdcdatavalues',
      component: CDCDataValuesPage
    }, {
      path: '/users',
      name: 'users',
      component: UserPage
    }, {
      path: '/userpushtokens/:userid',
      name: 'userpushtokens',
      component: UserPushTokensPage
    }, {
      path: '/collections',
      name: 'collections',
      component: CollectionAddressesPage
    }, {
      path: '/pricing',
      name: 'pricing',
      component: PricingPage
    }, {
      path: '/anomalies',
      name: 'anomalies',
      component: AnomaliesPage
    }, {
      // Deliberately no "api" substring in the path: the dev proxy
      // ('/api/*' in vue.config.js) forwards any URL containing "api"
      // to the backend, so e.g. /admin/apitokens would never reach the SPA.
      path: '/admin/tokens',
      name: 'apitokens',
      component: ApiTokensPage
    }, {
      path: '/admin/emissions',
      name: 'emissioncoverage',
      component: EmissionCoveragePage
    }
    // , {
    //  path: '/emissions/:facilityid',
    //  name: 'emissions',
    //  component: EmissionsPage
    // },
  ]
})
